globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.LocalManagement = appCustomerSpace.Controllers.LocalManagement || {};
appCustomerSpace.Controllers.LocalManagement.Multicast = appCustomerSpace.Controllers.LocalManagement.Multicast || {};


appCustomerSpace.Controllers.LocalManagement.Multicast.PlatformsController = (function(superClass) {

    utils.extend(PlatformsController, superClass);

    function PlatformsController() {
      return PlatformsController.__super__.constructor.apply(this, arguments);
    }

    $.extend(PlatformsController.prototype, {
      init: function() {
        this.initEvents();

        return PlatformsController.__super__.init.apply(this, arguments);
      },
      initEvents: function() {
        var me = this;
        me.displayCharts();
      },
      displayCharts: function(){
        var me = this;
        Highcharts.setOptions({
          global: {
              useUTC: false
          },
          lang: appCustomerSpace.Modules.Charts.lang.t('highcharts'),
          plotOptions: {
            pie: {
              innerSize: '70%',
              allowPointSelect: false,
              dataLabels: { enabled: false },
              stickyTracking: false,
              point: {
                events: {
                  mouseOver: function(){
                    this.series.chart.setTitle({text: this.y + "%", style: {color: this.color}});
                  },
                  mouseOut: function(){
                    this.series.chart.setTitle({text: this.series.chart.series[0].data[0].y + "%", style: {color: '#4CAF50'}});
                  }
                }
              }
            }
          }
        });
      }
    });

    return PlatformsController;

})(appCustomerSpace.Controllers.LocalManagement.MainController);
